<template>

  <div class="eol-container-box">

    <a-button type="link" class="back-class-btn" @click="$router.push(`/${school_code}/school/activity/class?id=${$route.query.id}`)">{{ btnTxt}}</a-button>
    <div class="search-all-box">
      <a-form-model layout="inline" ref="ruleForm" :model="form">
        <a-form-model-item prop="username">
          <a-input v-model="form.username" class="search-input" placeholder="请输入账号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="name">
          <a-input v-model="form.name" class="search-input" placeholder="请输入姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="mobile">
          <a-input v-model="form.mobile" class="search-input" placeholder="请输入手机号"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="source_type">
          <a-select v-model="form.source_type" placeholder="请选择添加方式" style="width: 160px" class="multiple-select" dropdownClassName="multipleDrop">
            <a-select-option value="">请选择添加方式</a-select-option>
            <a-select-option v-for="(item, index) in workArr" :key="index" :value="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="search-btn" type="primary" @click="onSearch()">搜索</a-button>
          <a-button class="reset-btn" @click="resetForm()">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <div class="right-option-box">
        <a-button class="option-btn" type="primary" @click="studentChooseModal()">从学生库选择</a-button>
        <template v-if="showTableSelection">
          <a-button class="option-btn" type="primary" @click="cancelSelection()">取消批量删除</a-button>
          <a-button class="option-btn" type="primary" @click="selectedDelete()">确认删除</a-button>
        </template>
        <a-button v-else class="option-btn" type="primary" @click="manySelection()">批量删除</a-button>

      </div>
    </div>
    <div class="table-all-box">
      <a-table :row-selection="rowSelection" :columns="columns" :data-source="tableData" rowKey="id" :bordered="false" size="small" :pagination="false">
        <template slot="source_type" slot-scope="source_type">
          {{source_type == 1 ? '学生扫码加入': '教师添加'}}
        </template>
        <template slot="action" slot-scope="text, scope">
          <a-button type="link" @click="deleteStudentModal(scope)">删除</a-button>
        </template>
      </a-table>

      <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />

    </div>
    <CommonModal v-model="showDeleteModal" title="删除学生" confirmText="确定" @confirm="handleDeleteConfirm">
      <div class="delete-modal">
        确定删除学生吗？
      </div>
    </CommonModal>
    <CommonModal v-model="showChooseModal" title="从学生库选择" confirmText="确定" @confirm="handleChooseConfirm">
      <div class="choose-modal">
        <div class="search-all-box">
          <a-form-model layout="inline" ref="ruleChoose" :model="chooseForm">
            <a-form-model-item prop="username">
              <a-input v-model="chooseForm.username" class="search-input" placeholder="请输入账号"></a-input>
            </a-form-model-item>
            <a-form-model-item prop="name">
              <a-input v-model="chooseForm.name" class="search-input" placeholder="请输入姓名"></a-input>
            </a-form-model-item>
            <a-form-model-item prop="mobile">
              <a-input v-model="chooseForm.mobile" class="search-input" placeholder="请输入手机号"></a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button class="search-btn" type="primary" @click="onChooseSearch()">搜索</a-button>
              <a-button class="reset-btn" @click="resetChooseForm()">重置</a-button>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="table-all-box">
          <a-table :row-selection="{ selectedRowKeys: chooseRowKeys,onChange: onSelectChooseChange, getCheckboxProps: getCheckboxProps  }" :columns="columnsChoose" :data-source="tableChoose" rowKey="id" :bordered="false" size="small"
            :pagination="false"></a-table>

          <a-pagination class="school-pagination" v-model="choosePage" :total="chooseTotal" @change="pageChooseChange" show-less-items />

        </div>
      </div>
    </CommonModal>
  </div>

</template>
<script>
import CommonModal from "../../../components/CommonModal"
import { mapActions } from "vuex";
import services from '../../../assets/js/services';
export default {
  name: 'classStudent',
  components: {
    CommonModal
  },
  data () {
    return {
      school_code: localStorage.getItem("schoolCode"),
      btnTxt: '< 返回班级管理',
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        name: "",
        username: "",
        mobile: "",
        source_type: '',
      },
      workArr: [
        { id: 1, name: '学生扫码加入' },
        { id: 2, name: '教师添加' },
      ],
      showTableSelection: false, // 多选框是否显示
      selectedRowKeys: [], // 选中行key
      columns: [
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "姓名",
          dataIndex: "name",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
        {
          title: "添加方式",
          dataIndex: "source_type",
          scopedSlots: { customRender: 'source_type' },
        },
        {
          title: "添加时间",
          dataIndex: "created_at",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      columnsChoose: [
        {
          title: "账号",
          dataIndex: "username",
        },
        {
          title: "姓名",
          dataIndex: "name",
        },
        {
          title: "手机号",
          dataIndex: "mobile",
        },
      ],
      chooseForm: {
        name: "",
        username: "",
        mobile: "",
      },
      choosePage: 1,
      chooseSize: 10,
      chooseTotal: 0,
      tableChoose: [],
      chooseRowKeys: [], // 从学生库选择的行key
      showDeleteModal: false,
      showChooseModal: false,
      activity_id: '', //当前活动id
      class_id: '', //当前班级id
      studentId: '', // 单选删除时选中的学生id
    };
  },
  computed: {
    rowSelection () {
      let that = this
      const { selectedRowKeys, showTableSelection } = that;
      return showTableSelection ? {
        selectedRowKeys,
        onChange: that.onSelectChange
      } : null
    }
  },
  mounted () {
    this.activity_id = this.$route.query.id
    this.class_id = this.$route.query.cid
    this.getTableList()
  },
  methods: {
    ...mapActions(["getSchoolClassesMember", "filterSchoolClassesUser", "delSchoolClassesMember", "chooseSchoolClassesMember"]),
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        activity_id: this.activity_id,
        class_id: this.class_id,
        name: this.form.name,
        username: this.form.username,
        mobile: this.form.mobile,
        type: this.form.source_type,
      };
      this.getSchoolClassesMember(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.onSearch()
    },
    // 学生库弹窗列表
    getChooseTableList () {
      let params = {
        page: this.choosePage,
        size: this.chooseSize,
        activity_id: this.activity_id,
        name: this.chooseForm.name,
        username: this.chooseForm.username,
        mobile: this.chooseForm.mobile,
      };
      this.filterSchoolClassesUser(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.tableChoose = res.data.items;
          this.chooseTotal = res.data.total;
          // console.log(res.data)
        }
      });
    },
    // 学生库弹窗 - 搜索点击
    onChooseSearch () {
      this.choosePage = 1;
      this.chooseTotal = 0;
      this.tableChoose = []
      this.getChooseTableList();
    },
    // 学生库库弹窗 - 表格分页
    pageChooseChange (val) {
      this.choosePage = val;
      this.chooseTotal = 0;
      this.getChooseTableList();
    },
    // 学生库弹窗 - 搜索重置
    resetChooseForm () {
      this.$refs.ruleChoose.resetFields();
      this.onChooseSearch()
    },
    handleModalVisible (key, val) {
      this[key] = val
    },
    handleDeleteConfirm () {
      let id = this.delType == 1 ? this.studentId : this.selectedRowKeys.join(",")
      this.studentDelete({ id: id, data: { activity_id: this.activity_id, class_id: this.class_id, _method: 'delete' } })
    },
    onSelectChange (rows) {
      console.log('selectedRowKeys changed: ', rows);
      this.selectedRowKeys = rows
    },
    // 表格中 删除按钮 点击事件
    deleteStudentModal (item) {
      this.studentId = item.id
      this.delType = 1
      this.handleModalVisible('showDeleteModal', true)
    },
    // 班级添加和删除方法
    studentDelete (params) {
      this.delSchoolClassesMember(params).then(res => {
        if (res.code == "0000") {
          this.studentId = ''
          this.cancelSelection()
          this.$message.success(`删除成功`)
          this.handleModalVisible('showDeleteModal', false)
          this.resetForm()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 批量删除 按钮点击事件
    manySelection () {
      this.showTableSelection = true
    },
    // 取消批量删除
    cancelSelection () {
      this.showTableSelection = false
      this.selectedRowKeys = []
    },
    // 确认批量删除事件
    selectedDelete () {
      if (this.selectedRowKeys.length > 0) {
        this.delType = 2
        this.handleModalVisible("showDeleteModal", true)
      } else {
        this.$message.error('请选择要删除的学生')
      }
    },
    // 初始化要选择学生库数据
    initChooseTableData () {
      this.choosePage = 1
      this.chooseTotal = 0
      this.tableChoose = []
      this.chooseForm = {
        name: "",
        username: "",
        mobile: "",
      }
      this.chooseRowKeys = []
      this.getChooseTableList()
    },
    // 从学生库选择点击事件
    studentChooseModal () {
      this.handleModalVisible('showChooseModal', true)
      this.initChooseTableData()
    },
    // 学生库多选框点击事件
    onSelectChooseChange (rows) {
      console.log('selectedRowKeys changed: ', rows);
      this.chooseRowKeys = rows
    },
    getCheckboxProps (record) {
      return {
        props: {
          disabled: record.is_selected == 1,
          name: record.name,
        },
      };
    },
    // 从学生库选择确认事件
    handleChooseConfirm () {
      if (this.chooseRowKeys && this.chooseRowKeys.length > 0) {
        services.chooseSchoolClassesMember({ activity_id: this.activity_id, class_id: this.class_id, user_ids: this.chooseRowKeys.join(",") }).then(res => {
          if (res.code == "0000") {
            this.$message.success(`操作成功`)
            this.handleModalVisible('showChooseModal', false)
            this.resetForm()
          } else {
            this.$message.error(res.message)
          }
        })
      } else {
        this.$message.error('请选择要添加的学生账号')
      }
    }
  },
};
</script>

<style lang="less" scoped>
.back-class-btn {
    padding: 0 16px;
    height: 32px;
    background: #b84b3c;
    border-radius: 16px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    margin-bottom: 15px;
    line-height: 32px;
    &:hover {
        background: #a82822;
    }
}
.delete-modal {
    font-weight: bold;
    font-size: 16px;
    color: #373536;
    text-align: center;
}
.choose-modal {
    padding-top: 20px;
}
</style>